/**
 * @generated SignedSource<<8829982c2a48276bb8c42d81ab6acb34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "VibeFollowers",
    "kind": "LinkedField",
    "name": "unfollowUser",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "follower",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followingCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "following",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followersCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followingUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postItemFollowButtonUnfollowUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postItemFollowButtonUnfollowUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5b44776918201c9ae28953db7dc09956",
    "id": null,
    "metadata": {},
    "name": "postItemFollowButtonUnfollowUserMutation",
    "operationKind": "mutation",
    "text": "mutation postItemFollowButtonUnfollowUserMutation(\n  $userId: String!\n) {\n  unfollowUser(userId: $userId) {\n    id\n    follower {\n      id\n      followingCount\n    }\n    following {\n      id\n      followersCount\n      followingUser\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c849dd1de5dc0b2f3bc11d1b21cff2b9";

module.exports = node;
